import React, { useState, useMemo, useEffect } from 'react';
import './DinexaBiz.css';
import { 
    Box, Typography, Paper, BottomNavigation, BottomNavigationAction,
    Grid, Divider, List, ListItem, ListItemText, ListItemAvatar, Avatar,
    AppBar, Toolbar, IconButton, Badge, useTheme, LinearProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Accordion, AccordionSummary, AccordionDetails,
    FormControl, Select, MenuItem, Chip, Card, CardContent, Button, Collapse,
    Snackbar, Alert, Tooltip as MuiTooltip,
    Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress, TextField
} from '@mui/material';
import { 
    Dashboard as DashboardIcon, 
    TableRestaurant as TableIcon, 
    Insights as AnalyticsIcon, 
    Settings as SettingsIcon,
    Notifications as NotificationsIcon,
    TrendingUp as TrendingUpIcon,
    RestaurantMenu as FoodIcon,
    AccountBalanceWallet as WalletIcon,
    Storefront as StorefrontIcon,
    BarChart as BarChartIcon,
    ExpandMore as ExpandMoreIcon,
    ExpandLess as ExpandLessIcon,
    LocationOn as LocationOnIcon,
    DeliveryDining as DeliveryIcon,
    TakeoutDining as TakeawayIcon,
    RoomService as DineInIcon,
    PieChart as PieChartIcon,
    Refresh as RefreshIcon,
    ReceiptLong as ReceiptLongIcon,
    Sync as SyncIcon,
    AccessTime as AccessTimeIcon,
    WarningAmber as WarningIcon,
    Delete as DeleteIcon,
    CheckCircle as CheckCircleIcon,
    CalendarToday as CalendarTodayIcon,
    Search as SearchIcon
} from '@mui/icons-material';
import { useApp } from '../context/AppContext';
import { useLanguage } from '../context/LanguageContext';
import versionInfo from '../config/version.json';
import API_BASE_URL from '../config/api';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

// Pure Localization Dictionary (Strictly single selected language without mixed brackets)
const getBizText = (lang) => {
    if (lang === 'mr') {
        return {
            dashboard: 'डॅशबोर्ड',
            floor: 'फ्लोअर',
            analytics: 'अॅनालिटिक्स',
            settings: 'सेटिंग्ज',
            todaysOverview: 'आजचा आढावा',
            yesterdaysOverview: 'कालचा आढावा',
            weeksOverview: 'या आठवड्याचा आढावा',
            monthsOverview: 'या महिन्याचा आढावा',
            totalRevenue: 'एकूण विक्री (महसूल)',
            bills: 'एकूण बिले',
            avgBill: 'सरासरी बिल',
            cash: 'रोख विक्री',
            onlineUpi: 'ऑनलाइन / UPI विक्री',
            discounts: 'दिलेली सूट',
            expenses: 'झालेला खर्च',
            outletsStatistics: 'शाखानिहाय आकडेवारी',
            sevenDayTrend: '७ दिवसांचा विक्री आलेख',
            occupiedTables: 'चालू टेबल्स',
            runningValue: 'चालू ऑर्डर रक्कम',
            activeRunningOrders: 'चालू ऑर्डर्स',
            noActiveOrders: 'सध्या कोणतेही टेबल किंवा चालू ऑर्डर नाही.',
            allBranchesClear: 'सर्व शाखांमध्ये सध्या कोणतेही ऑर्डर चालू नाही.',
            noActiveInBranch: 'या शाखेत कोणतीही चालू ऑर्डर नाही.',
            counterOrder: 'काउंटर ऑर्डर',
            table: 'टेबल',
            billedStatus: '🧾 बिल तयार',
            cookingStatus: '🔥 किचनमध्ये चालू',
            waiter: 'वेटर',
            staff: 'कर्मचारी',
            emptyDraftWarning: '⚠️ रिकामी नोंद / ० पदार्थ',
            items: 'पदार्थ',
            qty: 'नग',
            hide: 'लपवा',
            details: 'तपशील',
            removeEntry: 'नोंद काढा',
            dateTime: 'तारीख व वेळ',
            branch: 'शाखा',
            orderId: 'ऑर्डर क्र.',
            activeKotItems: 'चालू ऑर्डर तपशील (KOT पदार्थ):',
            noItemsFound: 'या ऑर्डरमध्ये कोणतीही पदार्थ नोंद नाही.',
            dishName: 'पदार्थाचे नाव',
            rate: 'दर (₹)',
            amount: 'रक्कम (₹)',
            removeDialogTitle: 'ऑर्डर नोंद काढून टाकावी का?',
            removeDialogBody: 'तुम्हाला खात्री आहे का की ही चालू/अर्धवट ऑर्डर नोंद काढून टाकायची आहे? यामुळे संबंधित टेबल त्वरित मोकळे होईल.',
            cancel: 'रद्द करा',
            yesRemove: 'होय, नोंद काढा',
            removeSuccess: 'ऑर्डर नोंद यशस्वीरीत्या काढण्यात आली व टेबल मोकळे झाले!',
            removeFailed: 'ऑर्डर काढण्यात त्रुटी आली.',
            settleEntry: 'बिल सेटल करा',
            settleDialogTitle: 'हे बिल सेटल (पूर्ण) करावे का?',
            settleDialogBody: 'हा स्टेटस तात्काळ "Served" होईल आणि आजच्या एकूण विक्रीत (Total Sales) जमा होईल.',
            confirmSettle: 'होय, बिल सेटल करा',
            settling: 'सेटल करत आहे...',
            settleSuccess: 'बिल यशस्वीरीत्या सेटल झाले व विक्रीत जमा झाले!',
            settleFailed: 'बिल सेटल करण्यात त्रुटी आली.',
            today: 'आज',
            yesterday: 'काल',
            week: 'हा आठवडा',
            month: 'हा महिना',
            custom: 'कस्टम तारीख',
            customDate: 'कस्टम तारीख (कालावधी)',
            fromDate: 'पासून (From)',
            toDate: 'पर्यंत (To)',
            apply: 'लागू करा',
            customOverview: 'कस्टम कालावधी आढावा',
            salesTrend: 'विक्री आलेख',
            allBranches: '🏢 सर्व शाखा',
            channelPerformance: 'विक्री माध्यम वर्गीकरण',
            topSellingItems: 'सर्वाधिक खपाचे पदार्थ',
            soldQty: 'विक्री नग',
            revenue: 'एकूण रक्कम',
            dineIn: 'डाइन-इन',
            takeaway: 'पार्सल / टेकअवे',
            delivery: 'डिलिव्हरी',
            zomato: 'झोमॅटो',
            swiggy: 'स्वीगी',
            selectLanguage: 'सिस्टीम भाषा निवडा',
            goToPos: 'POS टर्मिनलवर जा',
            goToPosDesc: 'कॅशियर व बिलिंग स्क्रीनवर जा',
            checkingUpdates: 'नवीन अपडेट्स तपासत आहे...',
            outlet: 'शाखा',
            totalSales: 'एकूण विक्री',
            tax: 'टॅक्स / GST',
            discount: 'सूट',
            noBranchStats: 'या कालावधीसाठी कोणतीही आकडेवारी उपलब्ध नाही.',
            noTrendData: 'आलेख डेटा उपलब्ध नाही.'
        };
    }
    if (lang === 'hi') {
        return {
            dashboard: 'डैशबोर्ड',
            floor: 'फ्लोर',
            analytics: 'एनालिटिक्स',
            settings: 'सेटिंग्स',
            todaysOverview: 'आज का विवरण',
            yesterdaysOverview: 'कल का विवरण',
            weeksOverview: 'इस सप्ताह का विवरण',
            monthsOverview: 'इस महीने का विवरण',
            totalRevenue: 'कुल बिक्री (राजस्व)',
            bills: 'कुल बिल',
            avgBill: 'औसत बिल',
            cash: 'नकद बिक्री',
            onlineUpi: 'ऑनलाइन / UPI बिक्री',
            discounts: 'दी गई छूट',
            expenses: 'हुआ खर्च',
            outletsStatistics: 'शाखावार आंकड़े',
            sevenDayTrend: '७ दिनों का बिक्री रुझान',
            occupiedTables: 'चालू टेबल्स',
            runningValue: 'चालू ऑर्डर राशि',
            activeRunningOrders: 'चालू ऑर्डर्स',
            noActiveOrders: 'फिलहाल कोई टेबल या चालू ऑर्डर नहीं है।',
            allBranchesClear: 'सभी शाखाओं में फिलहाल कोई ऑर्डर चालू नहीं है।',
            noActiveInBranch: 'इस शाखा में कोई चालू ऑर्डर नहीं है।',
            counterOrder: 'काउंटर ऑर्डर',
            table: 'टेबल',
            billedStatus: '🧾 बिल तैयार',
            cookingStatus: '🔥 किचन में चालू',
            waiter: 'वेटर',
            staff: 'कर्मचारी',
            emptyDraftWarning: '⚠️ खाली प्रविष्टि / ० आइटम',
            items: 'आइटम',
            qty: 'मात्रा',
            hide: 'छिपाएं',
            details: 'विवरण',
            removeEntry: 'हटाएं',
            dateTime: 'दिनांक व समय',
            branch: 'शाखा',
            orderId: 'ऑर्डर आईडी',
            activeKotItems: 'चालू ऑर्डर विवरण (KOT आइटम):',
            noItemsFound: 'इस ऑर्डर में कोई आइटम नहीं मिला।',
            dishName: 'आइटम का नाम',
            rate: 'मूल्य (₹)',
            amount: 'कुल (₹)',
            removeDialogTitle: 'ऑर्डर प्रविष्टि हटाएं?',
            removeDialogBody: 'क्या आप सुनिश्चित हैं कि यह चालू/अधूरी ऑर्डर प्रविष्टि हटाना चाहते हैं? इससे संबंधित टेबल तुरंत खाली हो जाएगी।',
            cancel: 'रद्द करें',
            yesRemove: 'हाँ, हटाएं',
            removing: 'हटा रहा है...',
            removeSuccess: 'ऑर्डर प्रविष्टि सफलतापूर्वक हटा दी गई व टेबल खाली हो गई!',
            removeFailed: 'ऑर्डर हटाने में त्रुटि आई।',
            settleEntry: 'बिल सेटल करें',
            settleDialogTitle: 'क्या यह बिल सेटल (पूर्ण) करना है?',
            settleDialogBody: 'यह बिल तुरंत "Served" हो जाएगा और आज की कुल बिक्री में जुड़ जाएगा।',
            confirmSettle: 'हाँ, बिल सेटल करें',
            settling: 'सेटल हो रहा है...',
            settleSuccess: 'बिल सफलतापूर्वक सेटल हो गया व बिक्री में जुड़ गया!',
            settleFailed: 'बिल सेटल करने में त्रुटि आई।',
            today: 'आज',
            yesterday: 'कल',
            week: 'यह सप्ताह',
            month: 'यह महीना',
            custom: 'कस्टम दिनांक',
            customDate: 'कस्टम दिनांक (अवधि)',
            fromDate: 'से (From)',
            toDate: 'तक (To)',
            apply: 'लागू करें',
            customOverview: 'कस्टम अवधि विवरण',
            salesTrend: 'बिक्री रुझान',
            allBranches: '🏢 सभी शाखाएं',
            channelPerformance: 'बिक्री चैनल प्रदर्शन',
            topSellingItems: 'सर्वाधिक बिकने वाले आइटम',
            soldQty: 'बिक्री मात्रा',
            revenue: 'कुल राशि',
            dineIn: 'डाइन-इन',
            takeaway: 'पार्सल / टेकअवे',
            delivery: 'डिलीवरी',
            zomato: 'ज़ोमैटो',
            swiggy: 'स्वीगी',
            selectLanguage: 'सिस्टम भाषा चुनें',
            goToPos: 'POS टर्मिनल पर जाएं',
            goToPosDesc: 'कैशियर व बिलिंग स्क्रीन पर जाएं',
            checkingUpdates: 'नए अपडेट जांचे जा रहे हैं...',
            outlet: 'शाखा',
            totalSales: 'कुल बिक्री',
            tax: 'टैक्स / GST',
            discount: 'छूट',
            noBranchStats: 'इस अवधि के लिए कोई आंकड़े उपलब्ध नहीं हैं।',
            noTrendData: 'रुझान डेटा उपलब्ध नहीं है।'
        };
    }
    // Default English
    return {
        dashboard: 'Dashboard',
        floor: 'Floor',
        analytics: 'Analytics',
        settings: 'Settings',
        todaysOverview: "Today's Overview",
        yesterdaysOverview: "Yesterday's Overview",
        weeksOverview: "This Week's Overview",
        monthsOverview: "This Month's Overview",
        totalRevenue: 'Total Revenue',
        bills: 'Bills',
        avgBill: 'Avg Bill',
        cash: 'Cash Sales',
        onlineUpi: 'UPI / Online Sales',
        discounts: 'Discounts',
        expenses: 'Expenses',
        outletsStatistics: 'Outlets Statistics',
        sevenDayTrend: '7-Day Trend',
        occupiedTables: 'Occupied Tables',
        runningValue: 'Running Value',
        activeRunningOrders: 'Active Running Orders',
        noActiveOrders: 'No active tables / running orders at the moment.',
        allBranchesClear: 'All branches are currently clear.',
        noActiveInBranch: 'No active orders in this branch.',
        counterOrder: 'Counter Order',
        table: 'Table',
        billedStatus: '🧾 BILLED',
        cookingStatus: '🔥 COOKING',
        waiter: 'Waiter',
        staff: 'Staff',
        emptyDraftWarning: '⚠️ 0 Items (Empty Draft)',
        items: 'Items',
        qty: 'Qty',
        hide: 'Hide',
        details: 'Details',
        removeEntry: 'Remove Entry',
        dateTime: 'Date & Time',
        branch: 'Branch',
        orderId: 'Order ID',
        activeKotItems: 'Active KOT Items:',
        noItemsFound: 'No item records found in this order.',
        dishName: 'Dish Name',
        rate: 'Rate (₹)',
        amount: 'Amount (₹)',
        removeDialogTitle: 'Remove Order Entry?',
        removeDialogBody: 'Are you sure you want to remove this running/draft order entry? This will also immediately mark the table as Vacant.',
        cancel: 'Cancel',
        yesRemove: 'Yes, Remove Entry',
        removing: 'Removing...',
        removeSuccess: 'Order entry removed successfully & table freed!',
        removeFailed: 'Failed to remove order.',
        settleEntry: 'Settle Bill',
        settleDialogTitle: 'Settle this Order to Sales?',
        settleDialogBody: 'This order will be marked as Served and added to today\'s sales revenue.',
        confirmSettle: 'Confirm Settle',
        settling: 'Settling...',
        settleSuccess: 'Order settled successfully & recorded in sales!',
        settleFailed: 'Failed to settle order.',
        today: 'Today',
        yesterday: 'Yesterday',
        week: 'This Week',
        month: 'This Month',
        custom: 'Custom Range',
        customDate: 'Custom Date Range',
        fromDate: 'From Date',
        toDate: 'To Date',
        apply: 'Apply',
        customOverview: 'Custom Range Overview',
        salesTrend: 'Sales Trend',
        allBranches: '🏢 All Branches',
        channelPerformance: 'Channel Performance',
        topSellingItems: 'Top Selling Items',
        soldQty: 'Sold Qty',
        revenue: 'Revenue',
        dineIn: 'Dine-In',
        takeaway: 'Takeaway',
        delivery: 'Delivery',
        zomato: 'Zomato',
        swiggy: 'Swiggy',
        selectLanguage: 'Select Language',
        goToPos: 'Go to POS Terminal',
        goToPosDesc: 'Switch to cashier & billing terminal',
        checkingUpdates: 'Checking for updates...',
        outlet: 'Outlet',
        totalSales: 'Total Sales',
        tax: 'Tax',
        discount: 'Discount',
        noBranchStats: 'No branch statistics available for this period.',
        noTrendData: 'No trend data available.'
    };
};

// Indian Standard Time (IST) Formatter (DD-MM-YYYY hh:mm AM/PM)
const formatDateTimeIST = (dateInput) => {
    if (!dateInput) return '-';
    try {
        let d;
        if (typeof dateInput === 'string') {
            const iso = dateInput.replace(' ', 'T');
            d = new Date(iso);
        } else {
            d = new Date(dateInput);
        }
        if (isNaN(d.getTime())) return String(dateInput);

        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        const dateStr = `${day}-${month}-${year}`;

        const timeStr = d.toLocaleTimeString('en-IN', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });

        return `${dateStr} ${timeStr}`;
    } catch (e) {
        return String(dateInput);
    }
};

export default function DinexaBizView() {
    const theme = useTheme();
    const [currentTab, setCurrentTab] = useState(0);
    const { currentLanguage, switchLanguage } = useLanguage();
    const L = useMemo(() => getBizText(currentLanguage), [currentLanguage]);

    const { 
        orders, 
        tables, 
        menuItems, 
        categories, 
        accountingLedger, 
        bizAnalytics, 
        fetchBizAnalytics,
        branches,
        branchSettings,
        cancelOrder,
        forceSettleOrder,
        tenantSubdomain 
    } = useApp();
    
    // Accordion State
    const [expandedChart, setExpandedChart] = useState(false);
    const [expandedStats, setExpandedStats] = useState(true);
    const [loadingAnalytics, setLoadingAnalytics] = useState(false);

    // Remove / Clear Order Dialog State
    const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
    const [orderToRemove, setOrderToRemove] = useState(null);
    const [removingOrder, setRemovingOrder] = useState(false);

    // Force Settle Dialog State (Biz App)
    const [openSettleDialog, setOpenSettleDialog] = useState(false);
    const [orderToSettle, setOrderToSettle] = useState(null);
    const [settlePaymentMethod, setSettlePaymentMethod] = useState('cash');
    const [isSettlingOrder, setIsSettlingOrder] = useState(false);

    const [toastMsg, setToastMsg] = useState('');
    const [openToast, setOpenToast] = useState(false);
    const [toastSeverity, setToastSeverity] = useState('success');

    // Update Checking State
    const [updatingToast, setUpdatingToast] = useState(false);

    // Remove / Cancel running order handler
    const handleConfirmRemoveOrder = async () => {
        if (!orderToRemove) return;
        setRemovingOrder(true);

        try {
            const activeSubdomain = tenantSubdomain || localStorage.getItem('dinexa_active_tenant_subdomain') || localStorage.getItem('dinexa_tenant_subdomain') || 'annapurna';
            
            // 1. Call Backend API to cancel order and free table in Database
            const res = await fetch(`${API_BASE_URL}/tenant/orders/cancel?tenant=${encodeURIComponent(activeSubdomain)}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Tenant-Subdomain': activeSubdomain
                },
                body: JSON.stringify({
                    order_id: orderToRemove.id,
                    table_id: orderToRemove.table_id,
                    cancel_reason: 'Removed by Owner from Biz App'
                })
            });

            const data = await res.json();
            if (data.success) {
                // 2. Also update local AppContext state if in same session
                if (typeof cancelOrder === 'function') {
                    cancelOrder('Removed by Owner from Biz App', orderToRemove.table_id, orderToRemove.id);
                }

                setToastSeverity('success');
                setToastMsg(L.removeSuccess);
                setOpenToast(true);

                // 3. Immediately refresh Biz Floor analytics
                if (typeof fetchBizAnalytics === 'function') {
                    fetchBizAnalytics(selectedPeriod, selectedBranch, customFromDate, customToDate);
                }
            } else {
                setToastSeverity('error');
                setToastMsg(data.error || L.removeFailed);
                setOpenToast(true);
            }
        } catch (err) {
            console.error("Error removing running order:", err);
            setToastSeverity('error');
            setToastMsg(L.removeFailed + ': ' + (err.message || 'Network error'));
            setOpenToast(true);
        } finally {
            setRemovingOrder(false);
            setOpenRemoveDialog(false);
            setOrderToRemove(null);
        }
    };

    // Force Settle running order handler
    const handleConfirmSettleOrder = async () => {
        if (!orderToSettle) return;
        setIsSettlingOrder(true);
        try {
            if (typeof forceSettleOrder === 'function') {
                const res = await forceSettleOrder(orderToSettle.id, settlePaymentMethod);
                if (res && res.success) {
                    setToastSeverity('success');
                    setToastMsg(L.settleSuccess);
                    setOpenToast(true);
                    if (typeof fetchBizAnalytics === 'function') {
                        fetchBizAnalytics(selectedPeriod, selectedBranch, customFromDate, customToDate);
                    }
                } else {
                    setToastSeverity('error');
                    setToastMsg(res?.error || L.settleFailed);
                    setOpenToast(true);
                }
            }
        } catch (err) {
            console.error("Error settling running order:", err);
            setToastSeverity('error');
            setToastMsg(L.settleFailed + ': ' + (err.message || 'Error'));
            setOpenToast(true);
        } finally {
            setIsSettlingOrder(false);
            setOpenSettleDialog(false);
            setOrderToSettle(null);
        }
    };

    const handleCheckUpdate = () => {
        setUpdatingToast(true);
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistrations().then(registrations => {
                for (let registration of registrations) {
                    registration.update();
                }
            });
        }
        if ('caches' in window) {
            caches.keys().then(names => {
                for (let name of names) {
                    caches.delete(name);
                }
            });
        }
        setTimeout(() => {
            window.location.reload(true);
        }, 1000);
    };

    // Helper to get formatted date string 'YYYY-MM-DD'
    const getTodayDateStr = () => {
        const d = new Date();
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Filter States
    const [selectedPeriod, setSelectedPeriod] = useState('today');
    const [selectedBranch, setSelectedBranch] = useState('all');
    const [customFromDate, setCustomFromDate] = useState(getTodayDateStr);
    const [customToDate, setCustomToDate] = useState(getTodayDateStr);

    // Expanded State for Order KOT Item Details in Live Floor Tab
    const [expandedOrderIds, setExpandedOrderIds] = useState({});

    const toggleOrderDetails = (orderId) => {
        setExpandedOrderIds(prev => ({
            ...prev,
            [orderId]: !prev[orderId]
        }));
    };

    // Read GST setting
    const enableGst = localStorage.getItem('dinexa_gst_enabled') === 'true' || localStorage.getItem('dinexa_gst_enabled') === '1';

    // Auto-fetch Live Biz Analytics from Backend API
    const loadAnalyticsData = async (periodOverride = selectedPeriod, branchOverride = selectedBranch, fromOverride = customFromDate, toOverride = customToDate) => {
        if (typeof fetchBizAnalytics === 'function') {
            setLoadingAnalytics(true);
            try {
                await fetchBizAnalytics(periodOverride, branchOverride, fromOverride, toOverride);
            } catch (err) {
                console.error("Failed to load Biz Analytics:", err);
            } finally {
                setLoadingAnalytics(false);
            }
        }
    };

    useEffect(() => {
        if (selectedPeriod !== 'custom') {
            loadAnalyticsData(selectedPeriod, selectedBranch, customFromDate, customToDate);
        } else if (customFromDate && customToDate && customFromDate.length === 10 && customToDate.length === 10) {
            loadAnalyticsData(selectedPeriod, selectedBranch, customFromDate, customToDate);
        }
    }, [selectedPeriod, selectedBranch, customFromDate, customToDate]);

    const handleExpandChart = (event, isExpanded) => {
        setExpandedChart(isExpanded);
    };

    const handleExpandStats = (event, isExpanded) => {
        setExpandedStats(isExpanded);
    };

    // Available Branches List Helper (Always preserves all branches)
    const branchOptions = useMemo(() => {
        const list = [];
        if (bizAnalytics?.all_branches && Array.isArray(bizAnalytics.all_branches) && bizAnalytics.all_branches.length > 0) {
            bizAnalytics.all_branches.forEach(b => list.push({ id: b.id, name: b.name }));
        } else if (branches && branches.length > 0) {
            branches.forEach(b => list.push({ id: b.id, name: b.name }));
        } else if (bizAnalytics?.outlet_stats && bizAnalytics.outlet_stats.length > 0) {
            bizAnalytics.outlet_stats.forEach(b => list.push({ id: b.branch_id, name: b.outlet_name }));
        }
        return list;
    }, [branches, bizAnalytics]);

    // Get Branch Name Helper
    const getBranchName = (branchId) => {
        if (!branchId || branchId === 'all') return L.allBranches;
        const found = branchOptions.find(b => String(b.id) === String(branchId)) ||
            bizAnalytics?.all_branches?.find(b => String(b.id) === String(branchId)) ||
            bizAnalytics?.outlet_stats?.find(b => String(b.branch_id) === String(branchId)) ||
            branches?.find(b => String(b.id) === String(branchId));
        return found ? (found.name || found.outlet_name) : `Branch #${branchId}`;
    };

    // 1. Dashboard Revenue Calculations
    const totalRevenue = bizAnalytics?.outlet_stats?.reduce((sum, b) => sum + (Number(b.total_sales) || 0), 0) || 0;
    const totalOrdersCount = bizAnalytics?.outlet_stats?.reduce((sum, b) => sum + (Number(b.total_orders) || 0), 0) || 0;
    const totalDiscounts = bizAnalytics?.outlet_stats?.reduce((sum, b) => sum + (Number(b.total_discount) || 0), 0) || 0;
    const totalExpenses = bizAnalytics?.outlet_stats?.reduce((sum, b) => sum + (Number(b.total_expenses) || 0), 0) || 0;
    const totalCash = bizAnalytics?.outlet_stats?.reduce((sum, b) => sum + (Number(b.total_cash) || 0), 0) || 0;
    const totalOnline = bizAnalytics?.outlet_stats?.reduce((sum, b) => sum + (Number(b.total_online) || 0), 0) || 0;
    const totalZomato = bizAnalytics?.outlet_stats?.reduce((sum, b) => sum + (Number(b.zomato_sales) || 0), 0) || 0;
    const totalSwiggy = bizAnalytics?.outlet_stats?.reduce((sum, b) => sum + (Number(b.swiggy_sales) || 0), 0) || 0;

    // Check if aggregator columns (Zomato / Swiggy / Delivery) have any data
    const hasDeliveryOrders = (bizAnalytics?.outlet_stats || []).some(s => (s.delivery_orders || 0) > 0 || (s.delivery_sales || 0) > 0);
    const hasZomatoOrders = (bizAnalytics?.outlet_stats || []).some(s => (s.zomato_orders || 0) > 0 || (s.zomato_sales || 0) > 0);
    const hasSwiggyOrders = (bizAnalytics?.outlet_stats || []).some(s => (s.swiggy_orders || 0) > 0 || (s.swiggy_sales || 0) > 0);

    // 2. Live Floor Data (Direct from Live Backend API)
    const liveFloorData = bizAnalytics?.live_floor || {
        occupied_tables_count: 0,
        running_revenue: 0,
        running_orders_count: 0,
        running_orders: [],
        tables: []
    };

    const runningOrders = liveFloorData.running_orders || [];
    const occupiedTablesCount = liveFloorData.occupied_tables_count || 0;
    const runningRevenue = liveFloorData.running_revenue || 0;

    // Helper to get dish name strictly matching selected language
    const getItemDisplayName = (it) => {
        if (!it) return 'Dish';
        if (currentLanguage === 'mr') {
            return it.name_mr || it.nameMr || it.name || 'ऑर्डर डिश';
        } else if (currentLanguage === 'hi') {
            return it.name_hi || it.nameHi || it.name || 'ऑर्डर डिश';
        }
        return it.name || 'Dish';
    };

    // 3. Top Sellers (Direct from Live Backend API)
    const topSellers = useMemo(() => {
        if (bizAnalytics?.top_sellers && Array.isArray(bizAnalytics.top_sellers) && bizAnalytics.top_sellers.length > 0) {
            return bizAnalytics.top_sellers.map(item => ({
                id: item.item_id,
                name: currentLanguage === 'mr' ? (item.name_mr || item.name) : (currentLanguage === 'hi' ? (item.name_hi || item.name) : item.name),
                category: item.category_name,
                qty: Number(item.qty_sold) || 0,
                revenue: Number(item.total_revenue) || 0,
                image: item.image_url
            }));
        }
        return [];
    }, [bizAnalytics, currentLanguage]);

    // Channel Sales Summary for Analytics Tab
    const channelSummary = useMemo(() => {
        const summary = {
            dineIn: { label: L.dineIn, sales: 0, orders: 0, color: '#008751' },
            takeaway: { label: L.takeaway, sales: 0, orders: 0, color: '#2563eb' },
            delivery: { label: L.delivery, sales: 0, orders: 0, color: '#f59e0b' },
            zomato: { label: L.zomato, sales: 0, orders: 0, color: '#e11d48' },
            swiggy: { label: L.swiggy, sales: 0, orders: 0, color: '#fc8019' }
        };

        if (bizAnalytics?.outlet_stats) {
            bizAnalytics.outlet_stats.forEach(stat => {
                summary.dineIn.sales += Number(stat.dine_in_sales) || 0;
                summary.dineIn.orders += Number(stat.dine_in_orders) || 0;
                summary.takeaway.sales += Number(stat.takeaway_sales) || 0;
                summary.takeaway.orders += Number(stat.takeaway_orders) || 0;
                summary.delivery.sales += Number(stat.delivery_sales) || 0;
                summary.delivery.orders += Number(stat.delivery_orders) || 0;
                summary.zomato.sales += Number(stat.zomato_sales) || 0;
                summary.zomato.orders += Number(stat.zomato_orders) || 0;
                summary.swiggy.sales += Number(stat.swiggy_sales) || 0;
                summary.swiggy.orders += Number(stat.swiggy_orders) || 0;
            });
        }

        return summary;
    }, [bizAnalytics, L]);

    // Helper to format date display (YYYY-MM-DD -> DD/MM/YYYY)
    const formatDateDisplay = (dateStr) => {
        if (!dateStr) return '';
        try {
            const parts = dateStr.split('-');
            if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
        } catch (e) {}
        return dateStr;
    };

    // Reusable Branch & Period Selector Header
    const renderFilterHeader = (title, showPeriod = true) => (
        <Box sx={{ mb: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        {title}
                    </Typography>
                    {selectedBranch !== 'all' && (
                        <Chip 
                            icon={<LocationOnIcon sx={{ fontSize: '16px !important' }} />} 
                            label={getBranchName(selectedBranch)} 
                            size="small" 
                            color="primary" 
                            sx={{ fontWeight: 800, height: 24 }} 
                        />
                    )}
                </Box>

                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
                    {showPeriod && (
                        <FormControl size="small" sx={{ minWidth: 130 }}>
                            <Select
                                value={selectedPeriod}
                                onChange={(e) => setSelectedPeriod(e.target.value)}
                                displayEmpty
                                sx={{ bgcolor: 'white', borderRadius: 1.5, fontWeight: 700, fontSize: '0.85rem' }}
                            >
                                <MenuItem value="today">{L.today}</MenuItem>
                                <MenuItem value="yesterday">{L.yesterday}</MenuItem>
                                <MenuItem value="week">{L.week}</MenuItem>
                                <MenuItem value="month">{L.month}</MenuItem>
                                <MenuItem value="custom" sx={{ fontWeight: 800, color: '#0284c7' }}>📅 {L.customDate}</MenuItem>
                            </Select>
                        </FormControl>
                    )}

                    <FormControl size="small" sx={{ minWidth: 150 }}>
                        <Select
                            value={selectedBranch}
                            onChange={(e) => setSelectedBranch(e.target.value)}
                            displayEmpty
                            sx={{ bgcolor: 'white', borderRadius: 1.5, fontWeight: 700, fontSize: '0.85rem' }}
                        >
                            <MenuItem value="all">{L.allBranches}</MenuItem>
                            {branchOptions.map(branch => (
                                <MenuItem key={branch.id} value={branch.id}>{branch.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <IconButton 
                        size="small" 
                        onClick={() => loadAnalyticsData(selectedPeriod, selectedBranch, customFromDate, customToDate)} 
                        title="Refresh"
                        sx={{ bgcolor: 'white', border: '1px solid #cbd5e1' }}
                    >
                        <RefreshIcon fontSize="small" />
                    </IconButton>
                </Box>
            </Box>

            {/* Custom Date Range Picker Bar */}
            {showPeriod && selectedPeriod === 'custom' && (
                <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 1.5, 
                    mt: 1.5, 
                    p: 1.5, 
                    bgcolor: '#f8fafc', 
                    border: '1px solid #cbd5e1', 
                    borderRadius: 2, 
                    flexWrap: 'wrap' 
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, color: '#0369a1' }}>
                        <CalendarTodayIcon sx={{ fontSize: 20 }} />
                        <Typography variant="body2" sx={{ fontWeight: 800 }}>
                            {L.customDate}:
                        </Typography>
                    </Box>
                    <TextField
                        label={L.fromDate}
                        type="date"
                        size="small"
                        value={customFromDate}
                        onChange={(e) => setCustomFromDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        sx={{ bgcolor: 'white', borderRadius: 1, minWidth: 150 }}
                    />
                    <Typography variant="body2" sx={{ fontWeight: 900, color: '#64748b' }}>➔</Typography>
                    <TextField
                        label={L.toDate}
                        type="date"
                        size="small"
                        value={customToDate}
                        onChange={(e) => setCustomToDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        sx={{ bgcolor: 'white', borderRadius: 1, minWidth: 150 }}
                    />
                    <Button
                        variant="contained"
                        size="small"
                        startIcon={loadingAnalytics ? <CircularProgress size={16} color="inherit" /> : <SearchIcon />}
                        disabled={loadingAnalytics}
                        onClick={() => loadAnalyticsData(selectedPeriod, selectedBranch, customFromDate, customToDate)}
                        sx={{ 
                            bgcolor: '#008751', 
                            '&:hover': { bgcolor: '#006d41' }, 
                            fontWeight: 800, 
                            textTransform: 'none',
                            height: 40,
                            px: 2.5,
                            borderRadius: 1.5
                        }}
                    >
                        {loadingAnalytics ? '...' : L.apply}
                    </Button>
                </Box>
            )}
        </Box>
    );

    // ==========================================
    // TAB 1: DASHBOARD
    // ==========================================
    const renderDashboard = () => (
        <div className="biz-dashboard-container">
            {renderFilterHeader(
                selectedPeriod === 'today' ? L.todaysOverview : 
                selectedPeriod === 'yesterday' ? L.yesterdaysOverview : 
                selectedPeriod === 'week' ? L.weeksOverview : 
                selectedPeriod === 'month' ? L.monthsOverview : 
                `${L.customOverview} (${formatDateDisplay(customFromDate)} - ${formatDateDisplay(customToDate)})`
            )}
            
            {loadingAnalytics && <LinearProgress sx={{ mb: 2, borderRadius: 1 }} />}

            <div className="biz-card-horizontal primary">
                <div className="biz-card-title primary">{L.totalRevenue}</div>
                <div className="biz-card-value primary">₹{totalRevenue.toLocaleString()}</div>
                <div className="biz-metric-row">
                    <div className="biz-metric">
                        <span className="biz-metric-label">{L.bills}</span>
                        <span className="biz-metric-value">{totalOrdersCount}</span>
                    </div>
                    <div className="biz-metric">
                        <span className="biz-metric-label">{L.avgBill}</span>
                        <span className="biz-metric-value">₹{Math.round(totalRevenue / (totalOrdersCount || 1))}</span>
                    </div>
                </div>
            </div>

            <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid item xs={6} sm={3}>
                    <div className="biz-card-small">
                        <div className="biz-card-title-group biz-text-cash">
                            <WalletIcon fontSize="small" />
                            <span className="biz-card-title biz-text-cash">{L.cash}</span>
                        </div>
                        <div className="biz-card-value">₹{totalCash.toLocaleString()}</div>
                    </div>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <div className="biz-card-small">
                        <div className="biz-card-title-group biz-text-upi">
                            <WalletIcon fontSize="small" />
                            <span className="biz-card-title biz-text-upi">{L.onlineUpi}</span>
                        </div>
                        <div className="biz-card-value">₹{totalOnline.toLocaleString()}</div>
                    </div>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <div className="biz-card-small" style={{ borderLeft: '3px solid #cb202d' }}>
                        <div className="biz-card-title-group" style={{ color: '#cb202d' }}>
                            <TakeawayIcon fontSize="small" />
                            <span className="biz-card-title" style={{ color: '#cb202d', fontWeight: 800 }}>{L.zomato}</span>
                        </div>
                        <div className="biz-card-value" style={{ color: '#cb202d' }}>₹{totalZomato.toLocaleString()}</div>
                    </div>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <div className="biz-card-small" style={{ borderLeft: '3px solid #fc8019' }}>
                        <div className="biz-card-title-group" style={{ color: '#ea580c' }}>
                            <TakeawayIcon fontSize="small" />
                            <span className="biz-card-title" style={{ color: '#ea580c', fontWeight: 800 }}>{L.swiggy}</span>
                        </div>
                        <div className="biz-card-value" style={{ color: '#ea580c' }}>₹{totalSwiggy.toLocaleString()}</div>
                    </div>
                </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={6}>
                    <div className="biz-card-small">
                        <div className="biz-card-title">{L.discounts}</div>
                        <div className="biz-card-value biz-text-discount">₹{totalDiscounts.toLocaleString()}</div>
                    </div>
                </Grid>
                <Grid item xs={6}>
                    <div className="biz-card-small">
                        <div className="biz-card-title">{L.expenses}</div>
                        <div className="biz-card-value biz-text-expense">-₹{totalExpenses.toLocaleString()}</div>
                    </div>
                </Grid>
            </Grid>

            {/* Outlets Statistics Table Accordion */}
            <Accordion expanded={expandedStats} onChange={handleExpandStats} sx={{ mb: 2, borderRadius: '12px !important', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)', '&:before': { display: 'none' } }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6" sx={{ fontWeight: 800, color: 'text.secondary', display: 'flex', alignItems: 'center', gap: 1 }}>
                        <StorefrontIcon /> {L.outletsStatistics} ({selectedPeriod === 'custom' ? `${formatDateDisplay(customFromDate)} - ${formatDateDisplay(customToDate)}` : selectedPeriod.toUpperCase()})
                    </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ pt: 0, px: 0 }}>
                    <div className="biz-table-container" style={{ border: 'none', boxShadow: 'none', borderRadius: 0 }}>
                        <TableContainer sx={{ maxHeight: 440 }}>
                            <Table size="small" aria-label="outlets statistics" stickyHeader>
                                <TableHead>
                                    <TableRow sx={{ '& th': { bgcolor: '#f8fafc', fontWeight: 800, color: '#334155', fontSize: '0.75rem', py: 1.5, borderBottom: '2px solid #e2e8f0' } }}>
                                        <TableCell sx={{ pl: 2, minWidth: 120 }}>{L.outlet}</TableCell>
                                        <TableCell align="right" sx={{ minWidth: 100 }}>{L.totalSales}</TableCell>
                                        <TableCell align="right" sx={{ minWidth: 100, color: '#008751' }}>{L.dineIn}</TableCell>
                                        <TableCell align="right" sx={{ minWidth: 100, color: '#2563eb' }}>{L.takeaway}</TableCell>
                                        {hasDeliveryOrders && <TableCell align="right" sx={{ minWidth: 100, color: '#f59e0b' }}>{L.delivery}</TableCell>}
                                        {hasZomatoOrders && <TableCell align="right" sx={{ minWidth: 90, color: '#e11d48' }}>{L.zomato}</TableCell>}
                                        {hasSwiggyOrders && <TableCell align="right" sx={{ minWidth: 90, color: '#fc8019' }}>{L.swiggy}</TableCell>}
                                        {enableGst && <TableCell align="right" sx={{ minWidth: 80, color: '#64748b' }}>{L.tax}</TableCell>}
                                        <TableCell align="right" sx={{ minWidth: 80, color: '#f59e0b' }}>{L.discount}</TableCell>
                                        <TableCell align="right" sx={{ minWidth: 80, color: '#ef4444', pr: 2 }}>{L.expenses}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {loadingAnalytics ? (
                                        <TableRow>
                                            <TableCell colSpan={10} align="center" sx={{ py: 3 }}>
                                                <LinearProgress sx={{ width: '50%', mx: 'auto' }} />
                                            </TableCell>
                                        </TableRow>
                                    ) : bizAnalytics?.outlet_stats && bizAnalytics.outlet_stats.length > 0 ? (
                                        bizAnalytics.outlet_stats.map((stat) => (
                                            <TableRow key={stat.branch_id} sx={{ '&:hover': { bgcolor: '#f8fafc' }, '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell component="th" scope="row" sx={{ fontWeight: 700, color: '#0f172a', pl: 2 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                        <StorefrontIcon fontSize="small" sx={{ color: '#008751' }} />
                                                        <span>{stat.outlet_name}</span>
                                                    </Box>
                                                </TableCell>

                                                {/* Total Sales with Total Orders in Brackets */}
                                                <TableCell align="right">
                                                    <Typography sx={{ fontWeight: 800, color: '#0f172a', fontSize: '0.88rem' }}>
                                                        ₹{Number(stat.total_sales).toLocaleString()}
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 700 }}>
                                                        ({stat.total_orders || 0} {L.bills})
                                                    </Typography>
                                                </TableCell>

                                                {/* Dine-In Column */}
                                                <TableCell align="right">
                                                    <Typography sx={{ fontWeight: 700, color: '#008751', fontSize: '0.85rem' }}>
                                                        ₹{Number(stat.dine_in_sales || 0).toLocaleString()}
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ color: '#047857', fontWeight: 700 }}>
                                                        ({stat.dine_in_orders || 0})
                                                    </Typography>
                                                </TableCell>

                                                {/* Takeaway Column */}
                                                <TableCell align="right">
                                                    <Typography sx={{ fontWeight: 700, color: '#2563eb', fontSize: '0.85rem' }}>
                                                        ₹{Number(stat.takeaway_sales || 0).toLocaleString()}
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ color: '#1d4ed8', fontWeight: 700 }}>
                                                        ({stat.takeaway_orders || 0})
                                                    </Typography>
                                                </TableCell>

                                                {/* Delivery Column */}
                                                {hasDeliveryOrders && (
                                                    <TableCell align="right">
                                                        <Typography sx={{ fontWeight: 700, color: '#f59e0b', fontSize: '0.85rem' }}>
                                                            ₹{Number(stat.delivery_sales || 0).toLocaleString()}
                                                        </Typography>
                                                        <Typography variant="caption" sx={{ color: '#b45309', fontWeight: 700 }}>
                                                            ({stat.delivery_orders || 0})
                                                        </Typography>
                                                    </TableCell>
                                                )}

                                                {/* Zomato Column */}
                                                {hasZomatoOrders && (
                                                    <TableCell align="right">
                                                        <Typography sx={{ fontWeight: 700, color: '#e11d48', fontSize: '0.85rem' }}>
                                                            ₹{Number(stat.zomato_sales || 0).toLocaleString()}
                                                        </Typography>
                                                        <Typography variant="caption" sx={{ color: '#be123c', fontWeight: 700 }}>
                                                            ({stat.zomato_orders || 0})
                                                        </Typography>
                                                    </TableCell>
                                                )}

                                                {/* Swiggy Column */}
                                                {hasSwiggyOrders && (
                                                    <TableCell align="right">
                                                        <Typography sx={{ fontWeight: 700, color: '#fc8019', fontSize: '0.85rem' }}>
                                                            ₹{Number(stat.swiggy_sales || 0).toLocaleString()}
                                                        </Typography>
                                                        <Typography variant="caption" sx={{ color: '#c2410c', fontWeight: 700 }}>
                                                            ({stat.swiggy_orders || 0})
                                                        </Typography>
                                                    </TableCell>
                                                )}

                                                {/* Tax Column (Shown ONLY if enableGst is true) */}
                                                {enableGst && (
                                                    <TableCell align="right" sx={{ fontWeight: 600, color: '#64748b' }}>
                                                        ₹{Number(stat.total_tax).toLocaleString()}
                                                    </TableCell>
                                                )}

                                                {/* Discount */}
                                                <TableCell align="right" sx={{ fontWeight: 600, color: '#f59e0b' }}>
                                                    ₹{Number(stat.total_discount).toLocaleString()}
                                                </TableCell>

                                                {/* Expenses */}
                                                <TableCell align="right" sx={{ fontWeight: 600, color: '#ef4444', pr: 2 }}>
                                                    ₹{Number(stat.total_expenses).toLocaleString()}
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={10} align="center" sx={{ py: 3, color: 'text.secondary' }}>
                                                {L.noBranchStats}
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </AccordionDetails>
            </Accordion>

            {/* 7-Day Revenue Trend Chart Accordion */}
            <Accordion expanded={expandedChart} onChange={handleExpandChart} sx={{ mb: 2, borderRadius: '12px !important', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)', '&:before': { display: 'none' } }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6" sx={{ fontWeight: 800, color: 'text.secondary', display: 'flex', alignItems: 'center', gap: 1 }}>
                        <BarChartIcon /> {selectedPeriod === 'custom' ? `${L.salesTrend} (${formatDateDisplay(customFromDate)} - ${formatDateDisplay(customToDate)})` : L.sevenDayTrend}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ pt: 0 }}>
                    <div className="biz-chart-container" style={{ border: 'none', boxShadow: 'none', marginBottom: 0, paddingRight: 0 }}>
                        {loadingAnalytics ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 220 }}>
                                <LinearProgress sx={{ width: '50%' }} />
                            </Box>
                        ) : bizAnalytics?.chart_data ? (
                            <ResponsiveContainer width="100%" height={220}>
                                <LineChart data={bizAnalytics.chart_data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
                                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" />
                                    <XAxis dataKey="date" axisLine={false} tickLine={false} tick={{ fontSize: 10, fill: '#64748b' }} dy={10} />
                                    <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 10, fill: '#64748b' }} tickFormatter={(value) => '₹' + (value/1000) + 'k'} />
                                    <Tooltip 
                                        contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                                        formatter={(value) => ['₹' + value, L.revenue]}
                                    />
                                    <Line type="monotone" dataKey="revenue" stroke="#008751" strokeWidth={3} dot={{ r: 4, fill: '#008751', strokeWidth: 2, stroke: '#fff' }} activeDot={{ r: 6 }} />
                                </LineChart>
                            </ResponsiveContainer>
                        ) : (
                            <Typography color="text.secondary" sx={{ textAlign: 'center', py: 5 }}>{L.noTrendData}</Typography>
                        )}
                    </div>
                </AccordionDetails>
            </Accordion>
        </div>
    );

    // ==========================================
    // TAB 2: LIVE FLOOR STATUS (Direct from Live Backend API)
    // ==========================================
    const renderLiveFloor = () => (
        <Box sx={{ p: 2, pb: 10 }}>
            {renderFilterHeader(L.floor, false)}

            {loadingAnalytics && <LinearProgress sx={{ mb: 2, borderRadius: 1 }} />}

            {/* Live Floor KPI Cards (Occupied Tables, Running Value, Zomato, Swiggy, Parcel) */}
            {(() => {
                const activeZomatoCount = runningOrders.filter(o => {
                    const src = String(o.order_source || '').toLowerCase();
                    const tp = String(o.type || '').toLowerCase();
                    return src === 'zomato' || tp.includes('zomato');
                }).length;

                const activeSwiggyCount = runningOrders.filter(o => {
                    const src = String(o.order_source || '').toLowerCase();
                    const tp = String(o.type || '').toLowerCase();
                    return src === 'swiggy' || tp.includes('swiggy');
                }).length;

                const activeParcelCount = runningOrders.filter(o => {
                    const src = String(o.order_source || '').toLowerCase();
                    const tp = String(o.type || '').toLowerCase();
                    const rawTbl = String(o.table_id || '').toLowerCase().trim();
                    const isAgg = src === 'zomato' || src === 'swiggy' || tp.includes('zomato') || tp.includes('swiggy');
                    if (isAgg) return false;
                    const isTakeaway = src === 'takeaway' || src === 'delivery' || src === 'parcel' || src === 'counter'
                        || tp.includes('takeaway') || tp.includes('delivery') || tp.includes('parcel') || tp.includes('counter')
                        || rawTbl === 'counter' || rawTbl.startsWith('ord-') || !rawTbl || rawTbl === 'null';
                    return isTakeaway;
                }).length;

                const activeDineInCount = (() => {
                    const tableKeys = new Set();
                    runningOrders.forEach(o => {
                        const src = String(o.order_source || '').toLowerCase();
                        const tp = String(o.type || '').toLowerCase();
                        const rawTbl = String(o.table_id || '').toLowerCase().trim();
                        const isAgg = src === 'zomato' || src === 'swiggy' || tp.includes('zomato') || tp.includes('swiggy');
                        const isNonDineIn = isAgg || src === 'takeaway' || src === 'delivery' || src === 'parcel' || src === 'counter'
                            || tp.includes('takeaway') || tp.includes('delivery') || tp.includes('parcel') || tp.includes('counter')
                            || rawTbl === 'counter' || rawTbl === 'null' || rawTbl === '' || rawTbl === 'undefined' || rawTbl.startsWith('ord-');
                        
                        if (!isNonDineIn && o.table_id) {
                            tableKeys.add(`${o.branch_id || 1}_${o.table_id}`);
                        }
                    });
                    return tableKeys.size;
                })();

                return (
                    <Grid container spacing={1.5} sx={{ mb: 3 }}>
                        <Grid item xs={6} sm={2.4}>
                            <Paper sx={{ p: 1.5, borderRadius: 2.5, textAlign: 'center', bgcolor: '#fff3cd', color: '#856404', border: '1px solid #ffeeba' }}>
                                <Typography variant="h5" sx={{ fontWeight: 900 }}>{activeDineInCount}</Typography>
                                <Typography variant="caption" sx={{ fontWeight: 800, display: 'block' }}>{L.occupiedTables}</Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={6} sm={2.4}>
                            <Paper sx={{ p: 1.5, borderRadius: 2.5, textAlign: 'center', bgcolor: '#d1e7dd', color: '#0f5132', border: '1px solid #c3e6cb' }}>
                                <Typography variant="h5" sx={{ fontWeight: 900 }}>₹{runningRevenue.toLocaleString()}</Typography>
                                <Typography variant="caption" sx={{ fontWeight: 800, display: 'block' }}>{L.runningValue}</Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={4} sm={2.4}>
                            <Paper sx={{ p: 1.5, borderRadius: 2.5, textAlign: 'center', bgcolor: '#fef2f2', color: '#cb202d', border: '1px solid #fecaca' }}>
                                <Typography variant="h5" sx={{ fontWeight: 900 }}>{activeZomatoCount}</Typography>
                                <Typography variant="caption" sx={{ fontWeight: 800, display: 'block' }}>🔴 {L.zomato}</Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={4} sm={2.4}>
                            <Paper sx={{ p: 1.5, borderRadius: 2.5, textAlign: 'center', bgcolor: '#fff7ed', color: '#ea580c', border: '1px solid #fed7aa' }}>
                                <Typography variant="h5" sx={{ fontWeight: 900 }}>{activeSwiggyCount}</Typography>
                                <Typography variant="caption" sx={{ fontWeight: 800, display: 'block' }}>🟠 {L.swiggy}</Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={4} sm={2.4}>
                            <Paper sx={{ p: 1.5, borderRadius: 2.5, textAlign: 'center', bgcolor: '#f1f5f9', color: '#334155', border: '1px solid #cbd5e1' }}>
                                <Typography variant="h5" sx={{ fontWeight: 900 }}>{activeParcelCount}</Typography>
                                <Typography variant="caption" sx={{ fontWeight: 800, display: 'block' }}>📦 {L.takeaway}</Typography>
                            </Paper>
                        </Grid>
                    </Grid>
                );
            })()}

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 900, color: '#0f172a' }}>
                    {L.activeRunningOrders} ({runningOrders.length})
                </Typography>
                <Chip 
                    label={getBranchName(selectedBranch)} 
                    size="small" 
                    sx={{ fontWeight: 700, bgcolor: '#e2e8f0' }} 
                />
            </Box>

            {runningOrders.length === 0 ? (
                <Paper sx={{ p: 4, textAlign: 'center', borderRadius: 3, bgcolor: '#ffffff', border: '1px dashed #cbd5e1' }}>
                    <TableIcon sx={{ fontSize: 48, color: '#94a3b8', mb: 1 }} />
                    <Typography variant="body1" sx={{ fontWeight: 700, color: '#475569' }}>
                        {L.noActiveOrders}
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#94a3b8' }}>
                        {selectedBranch === 'all' ? L.allBranchesClear : L.noActiveInBranch}
                    </Typography>
                </Paper>
            ) : (
                <List sx={{ bgcolor: 'background.paper', borderRadius: 3, boxShadow: '0 2px 8px rgba(0,0,0,0.04)', p: 0, overflow: 'hidden' }}>
                    {runningOrders.map((order, idx) => {
                        const rawTblLower = String(order.table_id || '').toLowerCase().trim();
                        const typeLower = String(order.type || '').toLowerCase();
                        const srcLower = String(order.order_source || '').toLowerCase();

                        const isZomato = srcLower === 'zomato' || typeLower.includes('zomato');
                        const isSwiggy = srcLower === 'swiggy' || typeLower.includes('swiggy');
                        const isDelivery = srcLower === 'delivery' || typeLower.includes('delivery');
                        const isTakeaway = srcLower === 'takeaway' || srcLower === 'parcel' || srcLower === 'counter'
                            || typeLower.includes('takeaway') || typeLower.includes('parcel') || typeLower.includes('counter')
                            || rawTblLower === 'counter' || rawTblLower.startsWith('ord-') || !rawTblLower || rawTblLower === 'null';

                        const isPhysicalTable = !isZomato && !isSwiggy && !isDelivery && !isTakeaway && Boolean(order.table_id && rawTblLower !== 'counter' && rawTblLower !== 'null' && rawTblLower !== 'undefined');

                        // Resolve clean table number / title
                        let cleanTableNumber = order.table_number || '';
                        if (!cleanTableNumber || cleanTableNumber.length > 15 || cleanTableNumber.includes('-') || cleanTableNumber.toLowerCase() === 'counter') {
                            const foundTbl = (liveFloorData.tables || []).find(t => String(t.id) === String(order.table_id));
                            if (foundTbl && foundTbl.number) {
                                cleanTableNumber = String(foundTbl.number);
                            } else if (order.type && !order.type.includes('-') && order.type.length < 15 && !order.type.toLowerCase().includes('counter')) {
                                cleanTableNumber = String(order.type).replace(/^(Table|टेबल)\s*/i, '');
                            } else if (isPhysicalTable) {
                                cleanTableNumber = String(order.table_id);
                            } else {
                                cleanTableNumber = 'Counter';
                            }
                        }

                        let titleText = '';
                        let avatarContent = '🍽️';
                        let avatarBg = '#008751';

                        if (isPhysicalTable) {
                            titleText = `${L.table} ${cleanTableNumber}`;
                            avatarContent = cleanTableNumber ? cleanTableNumber.substring(0, 4) : '🍽️';
                            avatarBg = '#008751';
                        } else if (isZomato) {
                            titleText = order.aggregator_order_id ? `🔴 Zomato (#${order.aggregator_order_id})` : '🔴 Zomato Order';
                            avatarContent = '🔴';
                            avatarBg = '#cb202d';
                        } else if (isSwiggy) {
                            titleText = order.aggregator_order_id ? `🟠 Swiggy (#${order.aggregator_order_id})` : '🟠 Swiggy Order';
                            avatarContent = '🟠';
                            avatarBg = '#fc8019';
                        } else if (isDelivery) {
                            titleText = '🛵 Direct Delivery';
                            avatarContent = '🛵';
                            avatarBg = '#0284c7';
                        } else {
                            titleText = `📦 ${L.counterOrder}`;
                            avatarContent = '📦';
                            avatarBg = '#475569';
                        }

                        const branchLabel = order.branch_name || getBranchName(order.branch_id);
                        const isBilled = order.status === 'billed';
                        const isExpanded = !!expandedOrderIds[order.id];
                        const items = order.items || [];
                        const totalItemQty = items.reduce((sum, it) => sum + (Number(it.quantity) || 0), 0);
                        const orderTimeIST = formatDateTimeIST(order.created_at);
                        const hasNoItems = items.length === 0;

                        return (
                            <React.Fragment key={order.id}>
                                <Box sx={{ p: 2, '&:hover': { bgcolor: '#f8fafc' }, bgcolor: hasNoItems ? '#fffbeb' : 'inherit' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1.5 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1, minWidth: 260 }}>
                                            <Avatar sx={{ bgcolor: isBilled ? '#ef4444' : (hasNoItems ? '#f59e0b' : avatarBg), color: '#ffffff', fontWeight: 900, width: 46, height: 46, fontSize: '0.95rem' }}>
                                                {avatarContent}
                                            </Avatar>
                                            <Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 0.3 }}>
                                                    <Typography sx={{ fontWeight: 900, color: '#0f172a', fontSize: '1rem' }}>
                                                        {titleText}
                                                    </Typography>

                                                    {/* Channel Badge (Dine-In / Zomato / Swiggy / Delivery / Parcel) */}
                                                    {isPhysicalTable ? (
                                                        <Chip label="🍽️ Dine-In" size="small" sx={{ height: 20, fontSize: '0.7rem', fontWeight: 900, bgcolor: '#f0fdf4', color: '#008751', border: '1px solid #bbf7d0' }} />
                                                    ) : (isZomato ? (
                                                        <Chip label={`🔴 Zomato ${order.aggregator_order_id ? `#${order.aggregator_order_id}` : ''}`} size="small" sx={{ height: 20, fontSize: '0.7rem', fontWeight: 900, bgcolor: '#fef2f2', color: '#cb202d', border: '1px solid #fecaca' }} />
                                                    ) : (isSwiggy ? (
                                                        <Chip label={`🟠 Swiggy ${order.aggregator_order_id ? `#${order.aggregator_order_id}` : ''}`} size="small" sx={{ height: 20, fontSize: '0.7rem', fontWeight: 900, bgcolor: '#fff7ed', color: '#fc8019', border: '1px solid #fed7aa' }} />
                                                    ) : (isDelivery ? (
                                                        <Chip label="🛵 Delivery" size="small" sx={{ height: 20, fontSize: '0.7rem', fontWeight: 900, bgcolor: '#f0f9ff', color: '#0284c7', border: '1px solid #bae6fd' }} />
                                                    ) : (
                                                        <Chip label="📦 Parcel" size="small" sx={{ height: 20, fontSize: '0.7rem', fontWeight: 900, bgcolor: '#f8fafc', color: '#475569', border: '1px solid #cbd5e1' }} />
                                                    ))))}
                                                    
                                                    {/* Branch Badge */}
                                                    <Chip 
                                                        icon={<LocationOnIcon sx={{ fontSize: '12px !important' }} />} 
                                                        label={branchLabel} 
                                                        size="small" 
                                                        sx={{ height: 20, fontSize: '0.72rem', fontWeight: 800, bgcolor: '#eff6ff', color: '#1d4ed8' }} 
                                                    />

                                                    {/* Status Badge */}
                                                    <Chip 
                                                        label={isBilled ? L.billedStatus : L.cookingStatus} 
                                                        size="small" 
                                                        sx={{ 
                                                            height: 20, 
                                                            fontSize: '0.7rem', 
                                                            fontWeight: 900, 
                                                            bgcolor: isBilled ? '#fef2f2' : '#fefce8', 
                                                            color: isBilled ? '#dc2626' : '#ca8a04',
                                                            border: isBilled ? '1px solid #fecaca' : '1px solid #fef08a'
                                                        }} 
                                                    />

                                                    {/* Date & Time IST Badge */}
                                                    <Chip 
                                                        icon={<AccessTimeIcon sx={{ fontSize: '13px !important', color: '#0284c7' }} />} 
                                                        label={orderTimeIST} 
                                                        size="small" 
                                                        sx={{ 
                                                            height: 20, 
                                                            fontSize: '0.72rem', 
                                                            fontWeight: 800, 
                                                            bgcolor: '#f0f9ff', 
                                                            color: '#0369a1',
                                                            border: '1px solid #bae6fd'
                                                        }} 
                                                    />
                                                </Box>

                                                {/* Details Subtitle */}
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                                    <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700 }}>
                                                        🕒 {orderTimeIST} • 👨‍🍳 {L.waiter}: <strong>{order.waiter_name || L.staff}</strong> • 🆔 #{order.id}
                                                    </Typography>
                                                    {hasNoItems ? (
                                                        <Chip 
                                                            icon={<WarningIcon sx={{ fontSize: '12px !important' }} />}
                                                            label={L.emptyDraftWarning}
                                                            size="small"
                                                            sx={{ height: 18, fontSize: '0.68rem', fontWeight: 800, bgcolor: '#fef2f2', color: '#dc2626' }}
                                                        />
                                                    ) : (
                                                        <Typography variant="caption" sx={{ color: '#0f766e', fontWeight: 800 }}>
                                                            🍽️ {items.length} {L.items} ({totalItemQty} {L.qty})
                                                        </Typography>
                                                    )}
                                                </Box>
                                            </Box>
                                        </Box>

                                        {/* Amount & Action Buttons */}
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                            <Typography variant="subtitle1" sx={{ fontWeight: 900, color: '#008751', fontSize: '1.1rem', whiteSpace: 'nowrap', mr: 0.5 }}>
                                                ₹{Number(order.total || order.subtotal || 0).toLocaleString()}
                                            </Typography>
                                            
                                            <Button
                                                size="small"
                                                variant={isExpanded ? "contained" : "outlined"}
                                                onClick={() => toggleOrderDetails(order.id)}
                                                startIcon={isExpanded ? <ExpandLessIcon sx={{ fontSize: '16px !important' }} /> : <ReceiptLongIcon sx={{ fontSize: '16px !important' }} />}
                                                sx={{
                                                    fontWeight: 800,
                                                    fontSize: '0.75rem',
                                                    borderRadius: 2,
                                                    textTransform: 'none',
                                                    py: 0.4,
                                                    px: 1.2,
                                                    bgcolor: isExpanded ? '#008751' : 'transparent',
                                                    borderColor: isExpanded ? '#008751' : '#cbd5e1',
                                                    color: isExpanded ? '#ffffff' : '#0f172a',
                                                    '&:hover': {
                                                        bgcolor: isExpanded ? '#007043' : '#f1f5f9',
                                                        borderColor: '#008751'
                                                    }
                                                }}
                                            >
                                                {isExpanded ? L.hide : L.details}
                                            </Button>

                                            <Button
                                                size="small"
                                                variant="contained"
                                                color="success"
                                                onClick={() => {
                                                    setOrderToSettle(order);
                                                    setSettlePaymentMethod(order.payment_method || order.paymentMethod || 'cash');
                                                    setOpenSettleDialog(true);
                                                }}
                                                startIcon={<CheckCircleIcon sx={{ fontSize: '16px !important' }} />}
                                                sx={{
                                                    fontWeight: 800,
                                                    fontSize: '0.75rem',
                                                    borderRadius: 2,
                                                    textTransform: 'none',
                                                    py: 0.4,
                                                    px: 1.2,
                                                    bgcolor: '#16a34a',
                                                    '&:hover': {
                                                        bgcolor: '#15803d'
                                                    }
                                                }}
                                            >
                                                {L.settleEntry}
                                            </Button>

                                            <Button
                                                size="small"
                                                variant="outlined"
                                                color="error"
                                                onClick={() => {
                                                    setOrderToRemove(order);
                                                    setOpenRemoveDialog(true);
                                                }}
                                                startIcon={<DeleteIcon sx={{ fontSize: '16px !important' }} />}
                                                sx={{
                                                    fontWeight: 800,
                                                    fontSize: '0.75rem',
                                                    borderRadius: 2,
                                                    textTransform: 'none',
                                                    py: 0.4,
                                                    px: 1.2,
                                                    borderColor: '#fca5a5',
                                                    color: '#dc2626',
                                                    bgcolor: '#fef2f2',
                                                    '&:hover': {
                                                        bgcolor: '#fee2e2',
                                                        borderColor: '#ef4444'
                                                    }
                                                }}
                                            >
                                                {L.removeEntry}
                                            </Button>
                                        </Box>
                                    </Box>

                                    {/* Collapsible Order KOT Items Details */}
                                    <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                                        <Box sx={{ mt: 1.5, p: 1.8, bgcolor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
                                            {/* Order Meta Info Strip */}
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 1.5, p: 1, bgcolor: '#ffffff', borderRadius: 1.5, border: '1px solid #e2e8f0', fontSize: '0.78rem' }}>
                                                <div><strong>📅 {L.dateTime}:</strong> <span style={{ color: '#0369a1', fontWeight: 800 }}>{orderTimeIST}</span></div>
                                                <div><strong>🪑 {L.table}:</strong> <span style={{ fontWeight: 800 }}>{titleText}</span></div>
                                                <div><strong>🏢 {L.branch}:</strong> <span>{branchLabel}</span></div>
                                                <div><strong>👨‍🍳 {L.waiter}:</strong> <span>{order.waiter_name || L.staff}</span></div>
                                                <div><strong>🆔 {L.orderId}:</strong> <span style={{ fontFamily: 'monospace', fontWeight: 800 }}>#{order.id}</span></div>
                                            </Box>

                                            <Typography variant="caption" sx={{ fontWeight: 800, color: '#475569', display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
                                                <FoodIcon sx={{ fontSize: 16, color: '#ea580c' }} />
                                                {L.activeKotItems}
                                            </Typography>

                                            {items.length === 0 ? (
                                                <Paper sx={{ p: 2, textAlign: 'center', bgcolor: '#fff1f2', border: '1px dashed #fda4af', borderRadius: 2 }}>
                                                    <Typography variant="caption" sx={{ color: '#be123c', fontWeight: 800, display: 'block' }}>
                                                        {L.noItemsFound}
                                                    </Typography>
                                                </Paper>
                                            ) : (
                                                <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #e2e8f0', borderRadius: 1.5 }}>
                                                    <Table size="small">
                                                        <TableHead sx={{ bgcolor: '#f1f5f9' }}>
                                                            <TableRow>
                                                                <TableCell sx={{ fontWeight: 900, fontSize: '0.72rem', py: 0.8, width: 40 }}>#</TableCell>
                                                                <TableCell sx={{ fontWeight: 900, fontSize: '0.72rem', py: 0.8 }}>
                                                                    {L.dishName}
                                                                </TableCell>
                                                                <TableCell align="center" sx={{ fontWeight: 900, fontSize: '0.72rem', py: 0.8 }}>
                                                                    {L.qty}
                                                                </TableCell>
                                                                <TableCell align="right" sx={{ fontWeight: 900, fontSize: '0.72rem', py: 0.8 }}>
                                                                    {L.rate}
                                                                </TableCell>
                                                                <TableCell align="right" sx={{ fontWeight: 900, fontSize: '0.72rem', py: 0.8 }}>
                                                                    {L.amount}
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {items.map((it, iIdx) => {
                                                                const dishName = getItemDisplayName(it);
                                                                const itemPrice = Number(it.price) || 0;
                                                                const itemQty = Number(it.quantity) || 1;
                                                                const itemTotal = itemPrice * itemQty;

                                                                return (
                                                                    <TableRow key={it.id || iIdx} sx={{ '&:last-child td': { borderBottom: 0 } }}>
                                                                        <TableCell sx={{ fontSize: '0.75rem', py: 0.8, color: '#64748b', fontWeight: 700 }}>
                                                                            {iIdx + 1}
                                                                        </TableCell>
                                                                        <TableCell sx={{ fontSize: '0.8rem', py: 0.8, fontWeight: 700, color: '#0f172a' }}>
                                                                            {dishName}
                                                                            {it.notes && (
                                                                                <Typography variant="caption" sx={{ display: 'block', color: '#ea580c', fontSize: '0.7rem', fontWeight: 600 }}>
                                                                                    📝 {it.notes}
                                                                                </Typography>
                                                                            )}
                                                                        </TableCell>
                                                                        <TableCell align="center" sx={{ py: 0.8 }}>
                                                                            <Chip label={`x${itemQty}`} size="small" sx={{ fontWeight: 900, height: 18, fontSize: '0.7rem', bgcolor: '#fef3c7', color: '#b45309' }} />
                                                                        </TableCell>
                                                                        <TableCell align="right" sx={{ fontSize: '0.75rem', py: 0.8, color: '#64748b' }}>
                                                                            ₹{itemPrice.toFixed(0)}
                                                                        </TableCell>
                                                                        <TableCell align="right" sx={{ fontSize: '0.8rem', py: 0.8, fontWeight: 800, color: '#008751' }}>
                                                                            ₹{itemTotal.toFixed(0)}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                );
                                                            })}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            )}
                                        </Box>
                                    </Collapse>
                                </Box>
                                {idx < runningOrders.length - 1 && <Divider />}
                            </React.Fragment>
                        );
                    })}
                </List>
            )}
        </Box>
    );

    // ==========================================
    // TAB 3: ANALYTICS (Direct from Live Backend API)
    // ==========================================
    const renderAnalytics = () => (
        <Box sx={{ p: 2, pb: 10 }}>
            {renderFilterHeader(L.analytics, true)}

            {loadingAnalytics && <LinearProgress sx={{ mb: 2, borderRadius: 1 }} />}

            {/* Branch-wise Channel Distribution Card */}
            <Card sx={{ borderRadius: 3, mb: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.05)', border: '1px solid #e2e8f0' }}>
                <CardContent sx={{ p: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 800, color: '#0f172a', display: 'flex', alignItems: 'center', gap: 1 }}>
                            <PieChartIcon sx={{ color: '#008751' }} /> {L.channelPerformance} ({selectedPeriod === 'custom' ? `${formatDateDisplay(customFromDate)} - ${formatDateDisplay(customToDate)}` : selectedPeriod.toUpperCase()})
                        </Typography>
                        <Chip 
                            label={getBranchName(selectedBranch)} 
                            size="small" 
                            sx={{ fontWeight: 800, bgcolor: '#f1f5f9' }} 
                        />
                    </Box>

                    <Grid container spacing={1.5}>
                        <Grid item xs={6} sm={4}>
                            <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: '#f0fdf4', border: '1px solid #bbf7d0' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mb: 0.5 }}>
                                    <DineInIcon sx={{ fontSize: 18, color: '#008751' }} />
                                    <Typography variant="caption" sx={{ fontWeight: 800, color: '#008751' }}>{L.dineIn}</Typography>
                                </Box>
                                <Typography variant="h6" sx={{ fontWeight: 900, color: '#065f46' }}>
                                    ₹{channelSummary.dineIn.sales.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" sx={{ color: '#047857', fontWeight: 700 }}>
                                    {channelSummary.dineIn.orders} {L.bills}
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item xs={6} sm={4}>
                            <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: '#eff6ff', border: '1px solid #bfdbfe' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mb: 0.5 }}>
                                    <TakeawayIcon sx={{ fontSize: 18, color: '#2563eb' }} />
                                    <Typography variant="caption" sx={{ fontWeight: 800, color: '#2563eb' }}>{L.takeaway}</Typography>
                                </Box>
                                <Typography variant="h6" sx={{ fontWeight: 900, color: '#1e40af' }}>
                                    ₹{channelSummary.takeaway.sales.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" sx={{ color: '#1d4ed8', fontWeight: 700 }}>
                                    {channelSummary.takeaway.orders} {L.bills}
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item xs={6} sm={4}>
                            <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: '#fffbeb', border: '1px solid #fde68a' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mb: 0.5 }}>
                                    <DeliveryIcon sx={{ fontSize: 18, color: '#d97706' }} />
                                    <Typography variant="caption" sx={{ fontWeight: 800, color: '#d97706' }}>{L.delivery}</Typography>
                                </Box>
                                <Typography variant="h6" sx={{ fontWeight: 900, color: '#92400e' }}>
                                    ₹{channelSummary.delivery.sales.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" sx={{ color: '#b45309', fontWeight: 700 }}>
                                    {channelSummary.delivery.orders} {L.bills}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            {/* Top Selling Items */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 800, color: '#0f172a', display: 'flex', alignItems: 'center', gap: 1 }}>
                    <FoodIcon sx={{ color: '#008751' }} /> {L.topSellingItems} ({selectedPeriod.toUpperCase()})
                </Typography>
                <Chip 
                    label={`${topSellers.length} ${L.items}`} 
                    size="small" 
                    sx={{ fontWeight: 700, bgcolor: '#e2e8f0' }} 
                />
            </Box>

            <List sx={{ bgcolor: 'background.paper', borderRadius: 3, boxShadow: '0 2px 8px rgba(0,0,0,0.04)', p: 0, overflow: 'hidden' }}>
                {topSellers.map((item, idx) => (
                    <React.Fragment key={item.id || idx}>
                        <ListItem sx={{ py: 1.5, px: 2 }}>
                            <ListItemAvatar>
                                <Avatar 
                                    src={item.image || '/images/default_food.png'} 
                                    variant="rounded"
                                    sx={{ width: 44, height: 44, mr: 1, borderRadius: 2 }}
                                >
                                    <FoodIcon />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText 
                                primary={
                                    <Typography sx={{ fontWeight: 800, fontSize: '0.92rem', color: '#0f172a' }}>
                                        #{idx + 1}. {item.name}
                                    </Typography>
                                } 
                                secondary={
                                    <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700 }}>
                                        {item.qty} {L.soldQty} {item.category ? `• ${item.category}` : ''}
                                    </Typography>
                                }
                            />
                            <Typography variant="subtitle2" sx={{ fontWeight: 900, color: '#008751', fontSize: '0.95rem' }}>
                                ₹{item.revenue.toLocaleString()}
                            </Typography>
                        </ListItem>
                        {idx < topSellers.length - 1 && <Divider component="li" />}
                    </React.Fragment>
                ))}
            </List>
            
            {topSellers.length === 0 && !loadingAnalytics && (
                <Paper sx={{ p: 4, textAlign: 'center', borderRadius: 3, bgcolor: '#ffffff', border: '1px dashed #cbd5e1' }}>
                    <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 600 }}>
                        {L.noBranchStats}
                    </Typography>
                </Paper>
            )}
        </Box>
    );

    return (
        <Box sx={{ bgcolor: '#f1f5f9', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            {/* Owner Header */}
            <AppBar position="sticky" sx={{ bgcolor: 'white', color: 'text.primary', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                <Toolbar sx={{ px: 2 }}>
                    <TrendingUpIcon sx={{ color: '#008751', mr: 1 }} />
                    <Box sx={{ flexGrow: 1 }}>
                        <Typography variant="h6" sx={{ fontWeight: 900, color: '#008751', letterSpacing: '-0.5px', lineHeight: 1.1 }}>
                            Dinexa Biz
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700, fontSize: '0.7rem' }}>
                            {getBranchName(selectedBranch)}
                        </Typography>
                    </Box>

                    {/* Direct Quick Update Button in Header */}
                    <MuiTooltip title={`v${versionInfo.version}.${versionInfo.buildNumber} (${versionInfo.buildTime})`}>
                        <Button
                            size="small"
                            variant="outlined"
                            onClick={handleCheckUpdate}
                            startIcon={<SyncIcon sx={{ fontSize: '15px !important' }} />}
                            sx={{
                                mr: 1,
                                py: 0.4,
                                px: 1.2,
                                fontWeight: 800,
                                fontSize: '0.72rem',
                                borderRadius: 2,
                                borderColor: '#bbf7d0',
                                bgcolor: '#f0fdf4',
                                color: '#16a34a',
                                textTransform: 'none',
                                '&:hover': { bgcolor: '#dcfce7', borderColor: '#86efac' }
                            }}
                        >
                            🔄 {currentLanguage === 'mr' ? 'अपडेट' : (currentLanguage === 'hi' ? 'अपडेट' : 'Update')}
                        </Button>
                    </MuiTooltip>

                    <IconButton color="inherit" onClick={() => window.location.href = '/'}>
                        <Badge badgeContent={runningOrders.length} color="error">
                            <NotificationsIcon />
                        </Badge>
                    </IconButton>
                </Toolbar>
            </AppBar>

            {/* Scrollable Content */}
            <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
                {currentTab === 0 && renderDashboard()}
                {currentTab === 1 && renderLiveFloor()}
                {currentTab === 2 && renderAnalytics()}
                {currentTab === 3 && (
                    <Box sx={{ p: 2, pb: 10 }}>
                        <Typography variant="h6" sx={{ fontWeight: 900, mb: 2, color: '#0f172a' }}>
                            ⚙️ {L.settings}
                        </Typography>

                        {/* 1. Software Update Card */}
                        <Card sx={{ borderRadius: 3, mb: 2.5, border: '1.5px solid #bbf7d0', bgcolor: '#f0fdf4', boxShadow: 'none' }}>
                            <CardContent sx={{ p: 2.5 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
                                    <Avatar sx={{ bgcolor: '#008751', color: 'white', width: 44, height: 44 }}>
                                        <SyncIcon />
                                    </Avatar>
                                    <Box>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 900, color: '#065f46' }}>
                                            Dinexa Biz Live Software Update
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: '#047857', fontWeight: 800 }}>
                                            v{versionInfo.version}.{versionInfo.buildNumber} • {versionInfo.buildTime}
                                        </Typography>
                                    </Box>
                                </Box>

                                <Typography variant="body2" sx={{ color: '#166534', mb: 2, fontSize: '0.85rem', lineHeight: 1.4 }}>
                                    {currentLanguage === 'mr' 
                                        ? 'नवीन फीचर्स आणि सर्व्हरवरील सुधारणा त्वरित मिळवण्यासाठी खालील बटण दाबून अॅप अद्ययावत करा.' 
                                        : (currentLanguage === 'hi' 
                                            ? 'नए फीचर्स और नवीनतम सुधार तुरंत लोड करने के लिए ऐप को अपडेट करें।' 
                                            : 'Fetch latest cloud updates, features and bug fixes instantly without logging into POS terminal.')}
                                </Typography>

                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={handleCheckUpdate}
                                    startIcon={<SyncIcon />}
                                    sx={{
                                        bgcolor: '#008751',
                                        '&:hover': { bgcolor: '#007043' },
                                        fontWeight: 900,
                                        borderRadius: 2.5,
                                        py: 1.3,
                                        textTransform: 'none',
                                        fontSize: '0.95rem',
                                        boxShadow: '0 4px 12px rgba(0, 135, 81, 0.25)'
                                    }}
                                >
                                    🔄 {currentLanguage === 'mr' ? 'नवीन अपडेट तपासा' : (currentLanguage === 'hi' ? 'अपडेट्स जांचें' : 'Check for Updates')}
                                </Button>
                            </CardContent>
                        </Card>

                        {/* 2. Language Preference Card */}
                        <Card sx={{ borderRadius: 3, mb: 2.5, border: '1px solid #e2e8f0', bgcolor: 'white', boxShadow: 'none' }}>
                            <CardContent sx={{ p: 2.5 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#0f172a', mb: 1.5 }}>
                                    🌐 {L.selectLanguage}
                                </Typography>
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <Button
                                        variant={currentLanguage === 'mr' ? 'contained' : 'outlined'}
                                        onClick={() => switchLanguage('mr')}
                                        sx={{ 
                                            flex: 1, 
                                            fontWeight: 800, 
                                            borderRadius: 2, 
                                            textTransform: 'none', 
                                            bgcolor: currentLanguage === 'mr' ? '#008751' : 'transparent', 
                                            borderColor: currentLanguage === 'mr' ? '#008751' : '#cbd5e1',
                                            color: currentLanguage === 'mr' ? 'white' : '#334155',
                                            '&:hover': { bgcolor: currentLanguage === 'mr' ? '#007043' : '#f8fafc' }
                                        }}
                                    >
                                        मराठी
                                    </Button>
                                    <Button
                                        variant={currentLanguage === 'hi' ? 'contained' : 'outlined'}
                                        onClick={() => switchLanguage('hi')}
                                        sx={{ 
                                            flex: 1, 
                                            fontWeight: 800, 
                                            borderRadius: 2, 
                                            textTransform: 'none', 
                                            bgcolor: currentLanguage === 'hi' ? '#008751' : 'transparent', 
                                            borderColor: currentLanguage === 'hi' ? '#008751' : '#cbd5e1',
                                            color: currentLanguage === 'hi' ? 'white' : '#334155',
                                            '&:hover': { bgcolor: currentLanguage === 'hi' ? '#007043' : '#f8fafc' }
                                        }}
                                    >
                                        हिंदी
                                    </Button>
                                    <Button
                                        variant={currentLanguage === 'en' ? 'contained' : 'outlined'}
                                        onClick={() => switchLanguage('en')}
                                        sx={{ 
                                            flex: 1, 
                                            fontWeight: 800, 
                                            borderRadius: 2, 
                                            textTransform: 'none', 
                                            bgcolor: currentLanguage === 'en' ? '#008751' : 'transparent', 
                                            borderColor: currentLanguage === 'en' ? '#008751' : '#cbd5e1',
                                            color: currentLanguage === 'en' ? 'white' : '#334155',
                                            '&:hover': { bgcolor: currentLanguage === 'en' ? '#007043' : '#f8fafc' }
                                        }}
                                    >
                                        English
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>

                        {/* 3. Switch to POS Terminal */}
                        <List sx={{ bgcolor: 'white', borderRadius: 3, border: '1px solid #e2e8f0', p: 0, overflow: 'hidden' }}>
                            <ListItem button onClick={() => {
                                localStorage.removeItem('dinexa_app_mode');
                                window.location.href = '/?app=pos';
                            }} sx={{ py: 2, px: 2.5 }}>
                                <ListItemAvatar>
                                    <Avatar sx={{ bgcolor: '#eff6ff', color: '#1d4ed8' }}>
                                        <StorefrontIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText 
                                    primary={<Typography sx={{ fontWeight: 800, color: '#0f172a' }}>{L.goToPos}</Typography>} 
                                    secondary={<Typography variant="caption" sx={{ color: '#64748b', fontWeight: 600 }}>{L.goToPosDesc}</Typography>} 
                                />
                            </ListItem>
                        </List>
                    </Box>
                )}
            </Box>

            {/* Fixed Bottom Navigation */}
            <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }} elevation={8}>
                <BottomNavigation
                    showLabels
                    value={currentTab}
                    onChange={(event, newValue) => {
                        setCurrentTab(newValue);
                    }}
                    sx={{ 
                        height: 65,
                        '& .Mui-selected': {
                            color: '#008751 !important',
                            fontWeight: 800
                        }
                    }}
                >
                    <BottomNavigationAction label={L.dashboard} icon={<DashboardIcon />} />
                    <BottomNavigationAction label={L.floor} icon={<TableIcon />} />
                    <BottomNavigationAction label={L.analytics} icon={<AnalyticsIcon />} />
                    <BottomNavigationAction label={L.settings} icon={<SettingsIcon />} />
                </BottomNavigation>
            </Paper>

            {/* Remove / Clear Running Order Confirmation Dialog */}
            <Dialog
                open={openRemoveDialog}
                onClose={() => !removingOrder && setOpenRemoveDialog(false)}
                maxWidth="xs"
                fullWidth
                PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
            >
                <DialogTitle sx={{ fontWeight: 900, color: '#dc2626', display: 'flex', alignItems: 'center', gap: 1 }}>
                    <WarningIcon sx={{ color: '#dc2626', fontSize: 26 }} />
                    {L.removeDialogTitle}
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body2" sx={{ color: '#334155', fontWeight: 600, mb: 2 }}>
                        {L.removeDialogBody}
                    </Typography>

                    {orderToRemove && (
                        <Paper variant="outlined" sx={{ p: 2, bgcolor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0', fontSize: '0.85rem' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.8 }}>
                                <span style={{ color: '#64748b' }}>🪑 {L.table}:</span>
                                <strong style={{ color: '#0f172a' }}>{orderToRemove.table_id === 'counter' ? L.counterOrder : `${L.table} ${orderToRemove.table_id}`}</strong>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.8 }}>
                                <span style={{ color: '#64748b' }}>🕒 {L.dateTime}:</span>
                                <strong style={{ color: '#0369a1' }}>{formatDateTimeIST(orderToRemove.created_at)}</strong>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.8 }}>
                                <span style={{ color: '#64748b' }}>👨‍🍳 {L.waiter}:</span>
                                <strong>{orderToRemove.waiter_name || L.staff}</strong>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.8 }}>
                                <span style={{ color: '#64748b' }}>🆔 {L.orderId}:</span>
                                <strong style={{ fontFamily: 'monospace' }}>#{orderToRemove.id}</strong>
                            </Box>
                            <Divider sx={{ my: 1 }} />
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.95rem' }}>
                                <span><strong>💰 {L.amount}:</strong></span>
                                <strong style={{ color: '#008751' }}>₹{Number(orderToRemove.total || orderToRemove.subtotal || 0).toLocaleString()}</strong>
                            </Box>
                        </Paper>
                    )}
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                    <Button
                        variant="outlined"
                        onClick={() => setOpenRemoveDialog(false)}
                        disabled={removingOrder}
                        sx={{ fontWeight: 700, borderRadius: 2, textTransform: 'none', color: '#64748b', borderColor: '#cbd5e1' }}
                    >
                        {L.cancel}
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleConfirmRemoveOrder}
                        disabled={removingOrder}
                        startIcon={removingOrder ? <CircularProgress size={16} color="inherit" /> : <DeleteIcon />}
                        sx={{ fontWeight: 900, borderRadius: 2, textTransform: 'none', bgcolor: '#dc2626', '&:hover': { bgcolor: '#b91c1c' } }}
                    >
                        {removingOrder ? L.removing : L.yesRemove}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Force Settle Order Dialog (Biz App Mobile) */}
            <Dialog
                open={openSettleDialog}
                onClose={() => !isSettlingOrder && setOpenSettleDialog(false)}
                PaperProps={{ sx: { borderRadius: 3, p: 1, maxWidth: 420 } }}
            >
                <DialogTitle sx={{ fontWeight: 900, color: '#16a34a', display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CheckCircleIcon sx={{ color: '#16a34a' }} />
                    {L.settleDialogTitle}
                </DialogTitle>
                <DialogContent>
                    {orderToSettle && (
                        <Box sx={{ mt: 1 }}>
                            <Typography variant="body2" sx={{ color: '#475569', mb: 2 }}>
                                {L.settleDialogBody}
                            </Typography>
                            <Paper elevation={0} sx={{ p: 1.5, bgcolor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 2, mb: 2 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                    <Typography variant="caption" sx={{ fontWeight: 700, color: '#64748b' }}>{L.orderId}:</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 800, color: '#0f172a' }}>#{orderToSettle.id}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                    <Typography variant="caption" sx={{ fontWeight: 700, color: '#64748b' }}>{L.amount}:</Typography>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 900, color: '#008751' }}>₹{Number(orderToSettle.total || orderToSettle.subtotal || 0).toLocaleString()}</Typography>
                                </Box>
                            </Paper>
                            <FormControl fullWidth size="small">
                                <Select
                                    value={settlePaymentMethod}
                                    onChange={(e) => setSettlePaymentMethod(e.target.value)}
                                    sx={{ fontWeight: 800, borderRadius: 2 }}
                                >
                                    <MenuItem value="cash">💵 {currentLanguage === 'mr' ? 'कॅश (Cash)' : 'Cash'}</MenuItem>
                                    <MenuItem value="upi">📱 {currentLanguage === 'mr' ? 'यूपीआय (UPI)' : 'UPI / Online'}</MenuItem>
                                    <MenuItem value="zomato">🔴 Zomato</MenuItem>
                                    <MenuItem value="swiggy">🟠 Swiggy</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2, justifyContent: 'space-between' }}>
                    <Button
                        onClick={() => setOpenSettleDialog(false)}
                        disabled={isSettlingOrder}
                        variant="outlined"
                        color="inherit"
                        sx={{ borderRadius: 2, fontWeight: 700, textTransform: 'none' }}
                    >
                        {L.cancel}
                    </Button>
                    <Button
                        onClick={handleConfirmSettleOrder}
                        disabled={isSettlingOrder}
                        variant="contained"
                        color="success"
                        startIcon={isSettlingOrder ? <CircularProgress size={16} color="inherit" /> : <CheckCircleIcon />}
                        sx={{ borderRadius: 2, fontWeight: 900, textTransform: 'none', bgcolor: '#16a34a', '&:hover': { bgcolor: '#15803d' } }}
                    >
                        {isSettlingOrder ? L.settling : L.confirmSettle}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Action Feedback Toast */}
            <Snackbar
                open={openToast}
                autoHideDuration={4000}
                onClose={() => setOpenToast(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={() => setOpenToast(false)} severity={toastSeverity} sx={{ width: '100%', fontWeight: 800, borderRadius: 2 }}>
                    {toastMsg}
                </Alert>
            </Snackbar>

            {/* Update Notification Toast */}
            <Snackbar
                open={updatingToast}
                autoHideDuration={3000}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert severity="success" sx={{ width: '100%', fontWeight: 800, borderRadius: 2 }}>
                    🔄 {L.checkingUpdates} (v{versionInfo.version}.{versionInfo.buildNumber})
                </Alert>
            </Snackbar>
        </Box>
    );
}
